import { render } from "./PrsPersonList.vue?vue&type=template&id=8f64dae8"
import script from "./PrsPersonList.vue?vue&type=script&lang=js"
export * from "./PrsPersonList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__